import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'components',
    pluginName: 'PRODUCT',
    entityName: 'MEMORY',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

// Fetch memory action creators

export const fetchMemoryInit = () => {
    return crudActions.fetchInit();
};
export const fetchMemoryStart = () => {
    return crudActions.fetchStart();
};
export const fetchMemorySuccess = (fetchMemoryCount, listMemoryCount) => {
    return crudActions.fetchSuccess(fetchMemoryCount, listMemoryCount);
};
export const fetchMemoryFail = () => {
    return crudActions.fetchFail();
};


export const fetchMemoryCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchMemoryStart());
        try {
            let countRes = await rest.post("components/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchMemorySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchMemoryFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch memory."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchMemoryFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch memory."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchMemory = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchMemoryStart());
        try {
            let listRes = await rest.post("components/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchMemorySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchMemoryFail());
            return []

        } catch (error) {
            dispatch(fetchMemoryFail());
            return []
        }
    }
}


// Load memory action creators
export const loadMemoryInit = () => {
    return crudActions.loadInit();
};
export const loadMemoryStart = () => {
    return crudActions.loadStart();
};
export const loadMemorySuccess = loadedMemory => {
    return crudActions.loadSuccess(loadedMemory);
};
export const loadMemoryFail = error => {
    return crudActions.loadFail(error);
};
export const loadMemory = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create memory  action creators
export const createMemoryInit = () => {
    return crudActions.createInit();
};
export const createMemoryStart = () => {
    return crudActions.createStart();
};
export const createMemorySuccess = createdMemory => {
    return crudActions.createSuccess(createdMemory);
};
export const createMemoryFail = error => {
    return crudActions.createFail(error);
};

export const createMemory = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createMemoryStart());
        try {
            let res = await rest.post('/components/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createMemorySuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created memory.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createMemoryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create memory."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create memory."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createMemoryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit memory  action creators
export const editMemoryInit = () => {
    return crudActions.editInit();
};
export const editMemoryStart = () => {
    return crudActions.editStart();
};
export const editMemorySuccess = editedMemory => {
    return crudActions.editSuccess(editedMemory);
};
export const editMemoryFail = error => {
    return crudActions.editFail(error);
};
export const editMemory = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editMemoryStart());
        try {
            let res = await rest.post('/components/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editMemorySuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated memory.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editMemoryFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit memory."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit memory."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editMemoryFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete memory action creators
export const bulkDeleteMemoriesInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteMemoriesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteMemoriesSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteMemoriesFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteMemories = memoryIds => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, memoryIds);
    };
};

// Delete memory  action creators
export const deleteMemoryInit = () => {
    return crudActions.deleteInit();
};
export const deleteMemoryStart = () => {
    return crudActions.deleteStart();
};
export const deleteMemorySuccess = deletedMemory => {
    return crudActions.deleteSuccess(deletedMemory);
};
export const deleteMemoryFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteMemory = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

export const setMemories = (data) => {
    return ({
        type: 'HANDLE_MEMORIES',
        memories: { ...data, fromProduct: true }
    });
}
export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}
